// tslint:disable

import axios, { AxiosResponse } from 'axios';
import * as React from 'react';
import { InputField } from '../../components/fields/input.field';
import { Field, FormLib } from '../../components/libs/form.lib';
import { ResourceLoader } from '../../components/libs/resource-loader';
import { ToggleBoxComponent } from '../../components/structurals/toggle-box.component';
import { Environment } from '../../environment/environment';


export class AspireDetails extends React.Component<any, any> {
    public mediaPackFields = {
        title: new Field({
            title: 'Title',
            property: 'title'
        }),
        value: new Field({
            title: 'Url',
            property: 'value'
        })
    };

    public componentDidMount(): void {
        this.mediaPackFields.title.registerField();
        this.mediaPackFields.value.registerField();
    }

    onResourceLoaded(raw: any) {
        this.mediaPackFields.title.setValue(raw.payload.title, true, true);
        this.mediaPackFields.value.setValue(raw.payload.value, true, true);
    }

    async onSaveMediaPack() {
        try {
            const value = {
                payload: {
                    title: this.mediaPackFields.title.value,
                    value: this.mediaPackFields.value.value
                }
            };

            const response: AxiosResponse = await axios.put(`${Environment.get('api.base')}/json-object/media-pack`, value, {
                withCredentials: true
            });

            console.log(response);
        } catch (err) {
            console.log(err);
        }
    }

    render() {
        return <div className="col-xs-12">
            <div id="page-title">
                <h2>
                    Aspire site details
                </h2>
            </div>

            <ToggleBoxComponent title="Media Pack Details" color="green" alwaysOpen={true} preIcon="fa-building-o">
                <ResourceLoader
                    entity="json-object"
                    entityId="media-pack"
                    render={(form: FormLib, raw: any) => <div className="col-xs-12">
                        {this.onResourceLoaded(raw)}

                        <InputField
                            field={this.mediaPackFields.title}/>
                        <InputField
                            field={this.mediaPackFields.value}/>

                        <button className="btn btn-success" onClick={() => this.onSaveMediaPack()}>Save</button>
                    </div>}/>
            </ToggleBoxComponent>


        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/__templates/details/aspire.details.tsx